import React from 'react';
import videoImg from "../../assets/images/videoT.png";

const Video = () => {
    const [showModal, setShowModal] = React.useState(false);
    return (
        <div className='w-full bg-white relative overflow-hidden rounded-2xl'>
            <div onClick={() => setShowModal(true)} className="cursor-pointer">
                <img className='object-cover w-full h-full rounded-2xl' src={videoImg} alt="" />

                <div className="w-full h-full absolute top-0 flex justify-center content-center">
                    <div className="h-full w-full flex justify-center items-center">
                        <div

                            className="absolute z-40 flex h-20 w-20 items-center justify-center rounded-full bg-primary md:h-[100px] md:w-[100px]"
                        >
                            <span
                                className="absolute top-0 right-0 z-[-1] h-full w-full animate-ping rounded-full bg-primary bg-opacity-20 delay-300 duration-1000"
                            ></span>
                            <svg
                                width="23"
                                height="27"
                                viewBox="0 0 23 27"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M22.5 12.634C23.1667 13.0189 23.1667 13.9811 22.5 14.366L2.25 26.0574C1.58333 26.4423 0.750001 25.9611 0.750001 25.1913L0.750002 1.80866C0.750002 1.03886 1.58334 0.557731 2.25 0.942631L22.5 12.634Z"
                                    fill="white"
                                />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <>
                {showModal ? (
                    <>
                        <div onClick={() => setShowModal(false)}
                            className=" justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
                        >
                            <div className="relative w-full my-6 mx-auto max-w-3xl">
                                {/*content*/}
                                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                                    {/*header*/}
                                    {/* <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                                        <h3 className="text-3xl font-semibold">
                                            Modal Title
                                        </h3>
                                        <button
                                            className="p-1 ml-auto bg-transparent border-0 text-black opacity-100 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                                            onClick={() => setShowModal(false)}
                                        >
                                            <span className="bg-transparent text-black opacity-100 h-6 w-6 text-2xl block outline-none focus:outline-none">
                                                ×
                                            </span>
                                        </button>
                                    </div> */}
                                    {/*body*/}
                                    <div  onClick={() => setShowModal(true)}  className="relative md:p-6 p-1 flex-auto">
                                        <button
                                        title='Close Modal'
                                            className="absolute -top-0 -right-14 bg-white pb-3 px-2 rounded-full border-2 ml-auto text-black opacity-100 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                                            onClick={() => setShowModal(false)}
                                        >
                                            <span className="  text-black opacity-100 h-6 w-6 text-2xl block outline-none focus:outline-none">
                                                ×
                                            </span>
                                        </button>
                                        <iframe className="w-full aspect-video ..." src="https://www.youtube.com/embed/gh5RzbKwY5c"></iframe>
                                    </div>
                                    {/*footer*/}
                                    {/* <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                                        <button
                                            className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                            type="button"
                                            onClick={() => setShowModal(false)}
                                        >
                                            Close
                                        </button>
                                        <button
                                            className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                            type="button"
                                            onClick={() => setShowModal(false)}
                                        >
                                            Save Changes
                                        </button>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                    </>
                ) : null}
            </>
        </div >
    );
};

export default Video;